import { CHEQUE_RECEIPTS } from '../actionTypes';

export const fetchChequeReceipts = (action) => ({
  type: CHEQUE_RECEIPTS.FETCH,
  payload: action.payload,
});
